import { CallApi } from '@signavio/kraken'

import { ADMIN_API_BASE } from '../../callApi'
import { USER } from '../users'

export const collection = USER.collection

export const schema = USER.schema

export const create =
  (callApi: CallApi) =>
  (_: unknown, { id, systemUserId }: { id: string; systemUserId: string }) =>
    callApi(
      `${ADMIN_API_BASE}/systemUsers/${systemUserId}/organizations/${id}`,
      schema,
      {
        method: 'POST',
      }
    )
